<template>
  <div class="advantage">
    <!-- <h1>{{ msg }}</h1> -->
    <section class="">
      <div
        class="row typeface-palette cols-xs-space cols-sm-space cols-md-space"
      >
        <div class="col-sm-3">
          <div class="typeface-entry">
            <p class="iconimg"><img src="../assets/iconlist/01.png" /></p>
            <h5>{{ $t('homepage.advantages.Icon0.title') }}</h5>
            <p class="titles">{{ $t('homepage.advantages.Icon0.concent') }}</p>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="typeface-entry">
            <p class="iconimg"><img src="../assets/iconlist/02.png" /></p>
            <h5>{{ $t('homepage.advantages.Icon1.title') }}</h5>
            <p class="titles">
              {{ $t('homepage.advantages.Icon1.concent') }}
            </p>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="typeface-entry">
            <p class="iconimg"><img src="../assets/iconlist/03.png" /></p>
            <h5>{{ $t('homepage.advantages.Icon2.title') }}</h5>
            <p class="titles">
              {{ $t('homepage.advantages.Icon2.concent') }}
            </p>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="typeface-entry">
            <p class="iconimg"><img src="../assets/iconlist/04.png" /></p>
            <h5>{{ $t('homepage.advantages.Icon3.title') }}</h5>
            <p class="titles">{{ $t('homepage.advantages.Icon3.concent') }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'advantage',
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  // color: #42b983;
}
.hello {
  background: #f2f2f2;
  padding: 20px 0;
}
.typeface-palette .typeface-entry {
  background: #fff;
  position: relative;
  display: block;
  padding: 0.5rem;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 1.075rem;
  // img{ width: 100%;}
  margin-bottom: 15px;
  cursor: pointer;
  overflow: hidden; /* 确保图片在容器内不会溢出 */
  height: 274px;
  .iconimg {
    border: dashed 1px #aec4dd;
    padding: 0px 0;
    width: 90px;
    height: 90px;
    line-height: 90px;
    border-radius: 50%;
    text-align: center;
    margin: 20px auto;
    background: #f2f6fa;
    z-index: 2;
    img {
      max-width: 45px;
      transition: 0.3s;
      z-index: 5;
    }
  }
}
.typeface-entry img {
  border-radius: 0.375rem;
  // width: 100%; /* 或者你希望的初始宽度 */
  transition: transform 0.5s ease; /* 平滑过渡效果 */
  transform-origin: center; /* 设置缩放中心为图片中心 */
}

.typeface-entry:hover img {
  transform: scale(1.05); /* 放大图片 */
}
.typeface-entry:hover {
  background: #5aa0c7;
  h5 {
    color: #ffffff;
  }
  .titles {
    color: #ffffff;
  }
}

h5 {
  color: #5aa0c7;
  font-size: 16px;
}
.titles {
  font-size: 12px;
  font-size: 14px;
  color: #7f858c;
  padding: 10px 10px;
  text-align: center;
}

.advantage {
  padding: 25px 0;
}
</style>
